'use client';

import React from 'react';
import { TranslationConfig, TranslationContext } from './types';

export const InternalTranslationContext = React.createContext<TranslationContext>({});

export interface ProviderProps {
  children: React.ReactNode;
  namespaces: Record<string, any>;
  lang: string;
  defaultNS: TranslationConfig['defaultNS'];
}
export const InternalTranslationProvider = ({
  children,
  namespaces,
  lang,
  defaultNS,
}: ProviderProps) => (
  <InternalTranslationContext.Provider value={{ lang, namespaces, defaultNS }}>
    {children}
  </InternalTranslationContext.Provider>
);
